import { useEffect,useState } from "react";
import {
  defaultPagination
} from "utils/table";
import Breadcrumbs from "../../../../components/Breadcrumbs";


import { getRequestApproverList } from "api/services/common";
import { useSearchParams } from 'react-router-dom';



const RequestApprover = () => {
  const [requestApproverMapData, setRequestApproverMapData] = useState()
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();

  const [pageSettings , setPageSettings] = useState({
    ...defaultPagination,
    page: searchParams.get("page") || 1,
    pageSize: searchParams.get("size") || 50,
    sortType: searchParams.get("sort_type") || "",
    sortBy: searchParams.get("sort_byb") || "",

})






const toTitleCase = (str) => {
    return str
        .replace(/_/g, ' ') // Replace underscores with spaces
        .replace(/\b\w/g, char => char.toUpperCase()) // Capitalize each word
        .replace('Approver', 'Approver'); // Ensure 'Approver' remains unchanged
};


const getRequestApprover = () => {
  setLoading(true)

  // let _filters = [...filters].filter(item=> item.value)
  // const filter_params = _filters.reduce((acc, item) => {
  //     acc[item.key] = item.value;
  //     return acc;
  //   }, {});
  let filter_params = {}

    
  getRequestApproverList({
    sort_by:pageSettings?.sortBy,
    sort_type: pageSettings?.sortType,
    page_size: pageSettings?.pageSize,
    page: pageSettings?.page,
    ...filter_params

  }).then(response=>{
    setPageSettings({
      ...pageSettings,
      total: response.data.count
    })
    const responseData = response.data;

    const mappedData = Object.keys(responseData || {})
        .filter(key => key.includes('_approver') && responseData[key]?.user)
        .map((key, index) => ({
            id: index,
            title: toTitleCase(key), // Convert key to Title Case
            text: `${responseData[key].user.first_name} ${responseData[key].user.last_name}`,
            type: responseData[key].role,
           
        }));

    setRequestApproverMapData(mappedData)

    setLoading(false)
  }).catch(e=>{
    setLoading(false)
  })
}
useEffect(()=>{

    getRequestApprover()

},[pageSettings?.page, pageSettings?.pageSize, pageSettings?.sortBy, pageSettings?.sortType, pageSettings?.filters])



 const ListItem = ({ title, text, type }) => (
   <li style={{
     listStyle: "none",
     padding: "16px",
     marginBottom: "12px",
     background: "#ffffff",
     borderRadius: "8px",
     border: "1px solid #e0e0e0",
     transition: "all 0.3s ease",
     boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)"
   }}
   onMouseEnter={(e) => {
     e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)";
     e.currentTarget.style.transform = "translateY(-2px)";
   }}
   onMouseLeave={(e) => {
     e.currentTarget.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.05)";
     e.currentTarget.style.transform = "translateY(0)";
   }}
   >
     <div style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
       <div style={{
         width: "40px",
         height: "40px",
         borderRadius: "8px",
         background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
         display: "flex",
         alignItems: "center",
         justifyContent: "center",
         flexShrink: 0
       }}>
         <i className="fa fa-user-check" style={{ fontSize: "18px", color: "#ffffff" }}></i>
       </div>
       <div style={{ flex: 1, minWidth: 0 }}>
         <div style={{
           fontSize: "12px",
           fontWeight: "600",
           color: "#8b949e",
           textTransform: "uppercase",
           letterSpacing: "0.5px",
           marginBottom: "6px"
         }}>
           {title}
         </div>
         {(type == "mailto" || type == "tel") ? (
           <a 
             href={`${type}:${text}`} 
             style={{
               fontSize: "15px",
               fontWeight: "500",
               color: "#2563eb",
               textDecoration: "none",
               display: "inline-flex",
               alignItems: "center",
               gap: "6px"
             }}
             onMouseEnter={(e) => e.currentTarget.style.textDecoration = "underline"}
             onMouseLeave={(e) => e.currentTarget.style.textDecoration = "none"}
           >
             <i className={`fa ${type == "mailto" ? "fa-envelope" : "fa-phone"}`} style={{ fontSize: "12px" }}></i>
             {text}
           </a>
         ) : (
           <div style={{
             fontSize: "15px",
             fontWeight: "500",
             color: "#333",
             display: "flex",
             alignItems: "center",
             gap: "6px"
           }}>
             <i className="fa fa-user" style={{ fontSize: "12px", color: "#8b949e" }}></i>
             {text}
           </div>
         )}
       </div>
     </div>
   </li>
 );




  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <Breadcrumbs
            maintitle="Settings"
            title="Settings"
            subtitle="Request Approver"
            modal="#request_approver"
            name="Request Approver"
          />
          {/* /Page Header */}
          <div className="row">
            <div className="col-md-8 col-lg-6">
              <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                <div className="card-body p-4">
                  <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "24px" }}>
                    <div style={{
                      width: "48px",
                      height: "48px",
                      borderRadius: "12px",
                      background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                      <i className="fa fa-users-cog" style={{ fontSize: "20px", color: "#ffffff" }}></i>
                    </div>
                    <div>
                      <h3 style={{
                        fontSize: "20px",
                        fontWeight: "600",
                        color: "#333",
                        marginBottom: "4px"
                      }}>
                        Request Approver
                      </h3>
                      <p style={{
                        fontSize: "13px",
                        color: "#8b949e",
                        marginBottom: 0
                      }}>
                        Manage approvers for different request types
                      </p>
                    </div>
                  </div>
                  
                  {loading ? (
                    <div style={{ textAlign: "center", padding: "40px" }}>
                      <i className="fa fa-spinner fa-spin" style={{ fontSize: "24px", color: "#667eea" }}></i>
                      <p style={{ marginTop: "12px", color: "#8b949e", fontSize: "14px" }}>Loading approvers...</p>
                    </div>
                  ) : requestApproverMapData && requestApproverMapData.length > 0 ? (
                    <ul style={{ padding: 0, margin: 0 }}>
                      {requestApproverMapData.map((item, index) => (
                        <ListItem
                          id={item.id}
                          key={index}
                          title={item.title}
                          text={item.text}
                          type={item.type}
                        />
                      ))}
                    </ul>
                  ) : (
                    <div style={{
                      textAlign: "center",
                      padding: "40px",
                      background: "#f8f9fa",
                      borderRadius: "8px",
                      border: "1px dashed #dee2e6"
                    }}>
                      <i className="fa fa-inbox" style={{ fontSize: "32px", color: "#adb5bd", marginBottom: "12px" }}></i>
                      <p style={{ color: "#8b949e", fontSize: "14px", marginBottom: 0 }}>No approvers configured</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </>
  );
};

export default RequestApprover;
